export default __webpack_public_path__ + "static/media/view-users-icon.6b2c8faf.svg";